<template>
  <div>
    <Loading v-if="loading" />

    <v-container
      v-else
      class="px-3 px-sm-4 pt-8 pt-md-12 pt-lg-16 pb-12 pb-md-16 mb-md-10"
    >
      <Title>Tudo em um só lugar!</Title>

      <div class="mt-6 mt-md-8 mt-lg-10">
        <v-row class="ma-n3 ma-sm-n4">
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-for="({ banner, to }, keyItems) in items"
            :key="keyItems"
            class="pa-3 pa-sm-4 item"
          >
            <v-card v-if="to" :href="to" target="_blank" flat tile>
              <img
                :src="files + banner"
                class="d-block item-img"
                width="100%"
              />
            </v-card>
            <img
              v-else
              :src="files + banner"
              class="d-block item-img"
              width="100%"
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "pages-banners",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ img_banner_home, to }) => ({
        banner: img_banner_home,
        to,
      }));
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    box-shadow: 0px 8px 16px rgba(30, 46, 56, 0.2);
  }
}
</style>
